export default function generateWhatsappMessage({
  language,
  shareLink,
  patientName,
}: {
  language: string;
  shareLink: string;
  patientName?: string;
}) {
  switch (language) {
    case 'en_US':
      return encodeURIComponent(
        `The result of ${patientName}'s medical imaging study is now available. You can securely review it by clicking on the link at the end of this message.\n${shareLink}`,
      );
    default:
      return encodeURIComponent(
        `El resultado del estudio de ${patientName} se encuentra disponible. Puedes consultarlo de manera segura dando click al enlace al final de este mensaje.\n${shareLink}`,
      );
  }
}
